import type { SelectProps } from 'core/components/ui/Select';
import { Select } from 'core/components/ui/Select';
import { filterOption } from 'core/utils';

import { useUsers } from 'core/containers/UsersModal/hooks';
import type { UserModel } from 'core/services/users';

interface UserSelectorProps extends SelectProps {
  preview?: boolean;
}
export const getUserText = (u: UserModel) => {
  if (u.firstName && u.lastName) {
    return `${u.firstName} ${u.lastName}`;
  }
  if (u.userName) {
    return u.userName;
  }
  return u.email;
};

function UserSelector({ value = [], preview = false, ...props }: UserSelectorProps): JSX.Element {
  const { data: users } = useUsers();

  if (preview && users) {
    const assigneeUsers = users.items.filter((u: UserModel) => value.includes(u.id));

    if (assigneeUsers) {
      return <>{assigneeUsers.map((aU, i) => (i ? `, ${getUserText(aU)}` : getUserText(aU)))}</>;
    }
  }

  const options = users?.items.map((u: UserModel) => ({
    value: u.id,
    label: getUserText(u),
  }));

  return (
    <Select
      mode="multiple"
      filterOption={filterOption}
      options={options}
      showSearch
      style={{ width: '100%' }}
      value={value || null}
      {...props}
    />
  );
}

export { UserSelector };
